import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';

import { StatementWrapper, Title, Body, Ulist, Olist } from './styles';

const ModalStatements = ({ data }) => {
  if (!data) return null;

  const { heading, bodyCopy } = data;

  const title = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Title>{children}</Title>,
    },
  };

  const body = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
      [BLOCKS.OL_LIST]: (_, children) => <Olist>{children}</Olist>,
      [BLOCKS.UL_LIST]: (_, children) => <Ulist>{children}</Ulist>,
    },
  };

  return (
    <StatementWrapper>
      {(heading || bodyCopy) && (
        <Body>
          {heading && <RichText document={heading} options={title} />}
          {bodyCopy && <RichText document={bodyCopy} options={body} />}
        </Body>
      )}
    </StatementWrapper>
  );
};

ModalStatements.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ModalStatements;
